import { Button, Typography } from "antd";
import { QRCodeSVG } from "qrcode.react"
import CopyToClipboard from "react-copy-to-clipboard"
import { useCallback } from "react";
const { Text } = Typography;
const Authenticator = ({ handleVerifyCode, twofaGetData }) => {
    const handleVerifyNext = useCallback(() => {
        if (handleVerifyCode) {
            handleVerifyCode();
        }
    }, [handleVerifyCode])
    return (
        <>
           <div className="text-center p-3.5 mt-4">
                <h4 className="title text-lg text-whiteText font-semibold">Authenticator App</h4>
                <p className="description !text-whiteText">
                    Open your two-factor authentication app and do one of the following actions:
                </p>
                <div className="md:flex xl:flex lg:block justify-center gap-4">                   
                    <div className="border border-StrokeColor rounded-5 p-4">
                        <h4 className="sub-title !text-whiteText">Use the QR Code</h4>
                        <div className="qr-container">
                            <QRCodeSVG value={twofaGetData?.uri} className="qr-image !w-44 !h-44" />
                        </div>
                    </div>
                    <div className="!text-whiteText font-semibold  text-center self-center p-2">Or</div>
                    <div className="border border-StrokeColor rounded-5 p-4">
                        <div className="flex items-center justify-between mb-2">
                            <h4 className="text-whiteText font-medium text-base">Manually enter the code</h4>
                            <div className="w-6 h-6 rounded-full bg-lightBg flex justify-center items-center cursor-pointer">
                            <CopyToClipboard text={twofaGetData?.key} value={twofaGetData?.key} options={{ format: 'text/plain' }}>
                                <Text copyable={{ text: twofaGetData?.key, tooltips: ["Copy", "Copied"] }} className="copy-icon"></Text>
                            </CopyToClipboard>
                            </div>
                        </div>
                        <div className="copytext-bg !bg-lightBg mt-3">
                            <h4 className="copy-text text-whiteText">{twofaGetData?.key}</h4>
                        </div>
                    </div>
                    </div>
                <div className="button-container">
                    <Button className="primary-btn" type="primary" htmlType="submit" onClick={handleVerifyNext}>
                        Next Step
                    </Button>
                </div>
            </div>
        </>
    )
}
export default Authenticator